import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render results section for FAQ Page
 */
const ResultsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="results-section-component"
    >
      <AccordionV2
        testId="results"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="5. Do I apply for a specific Award category? When will I know the results?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p>
            You do not need to apply for a specific Award category. All
            applications will be reviewed by the official Auditor RSM, and
            shortlisted companies will be evaluated by the judging panel.
          </p>

          <p>
            The top finalists will be interviewed and evaluated further on the
            Judging Day. The winners of the sub-categories will be selected
            during the Judging Day. The results will only be announced at the
            Awards Ceremony Gala Dinner.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ResultsSection;
